import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { toRefs } from 'vue';
import MainPage from '@/components/Index/MainPage.vue';
import Index from '@/components/Index/Index.vue';
import { useGlobalStore } from '@/stores/global';
import { useWindowSize } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainPage',
  setup(__props) {

const { width } = useWindowSize();

const globalStore = useGlobalStore();
const { getExcursions, getCategories } = globalStore;
const { categories, excursions } = toRefs(globalStore);

const onLoad = async () => {
    if (!excursions.value?.data.length) {
        await getExcursions();
    }

    if (!categories.value?.data.length) {
        await getCategories();
    }
};

onLoad();

return (_ctx: any,_cache: any) => {
  return (_unref(width) < 1024)
    ? (_openBlock(), _createBlock(Index, { key: 0 }))
    : (_openBlock(), _createBlock(MainPage, { key: 1 }))
}
}

})